import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import FoundersCountdownBar from "@/components/FoundersCountdownBar";
import Footer from "@/components/Footer";
import CookieNotice from "@/components/CookieNotice";
import { captureAttribution } from "@/lib/attribution";
import { hasConsent, loadAnalytics, trackPage } from "@/lib/analytics";

const BRAND = "Futuregen Innovations";
const TITLES = {
  "/": "The future of regulated service compliance",
  "/pricing": "Plans & pricing — CQC & Ofsted compliance support",
  "/resources": "Policies, procedures & mock interviews",
  "/start-up": "New provider start-up toolkit — CQC & Ofsted registration",
  "/updates": "Live CQC & Ofsted regulatory updates",
  "/advertise": "Advertise to registered managers",
  "/guidance": "Compliance guidance articles for CQC & Ofsted managers",
  "/billing": "Billing & invoices",
  "/cqc": "CQC compliance support for registered managers & new care providers",
  "/ofsted": "Ofsted compliance support for children's homes, RIs and registered managers",
  "/aesthetics": "CQC registration & compliance for clinical aesthetics clinics",
  "/privacy": "Privacy Policy",
  "/terms": "Terms & Conditions",
  "/cookies": "Cookie Notice",
  "/suppliers": "Find a trusted supplier or service",
  "/partner": "Partner portal",
  "/inspection-day": "Inspection day mode",
  "/dashboard": "Dashboard",
  "/assistant": "AI compliance assistant",
  "/evidence": "Evidence folder",
  "/training": "Staff training log",
  "/inspections": "Inspection debrief",
  "/team": "Team",
  "/admin": "Admin",
};

export default function Layout() {
  const { pathname, hash } = useLocation();
  useEffect(() => { captureAttribution(); if (hasConsent()) loadAnalytics(); }, []);
  useEffect(() => { trackPage(pathname); if (!hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname, hash]);

  useEffect(() => {
    const t = TITLES[pathname];
    if (t || !pathname.startsWith("/guidance/")) document.title = t ? `${t} | ${BRAND}` : BRAND;
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", `https://futuregen-innovations.com${pathname === "/" ? "/" : pathname}`);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <FoundersCountdownBar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieNotice />
    </div>
  );
}
